export default __webpack_public_path__ + "static/media/CheckStep-Not-Eligible.fe75dfe5.svg";